import React from 'react';
import {
   StyleSheet,
   SafeAreaView,
   View,
   TouchableOpacity,
   Image,
   Text,
   Platform,
} from 'react-native';
import {
   appBackground,
   drawerListBackgroundColor,
   getNavBarHeight,
   getStatusBarHeight,
   FONT_FAMILY_REGULAR,
} from './utils';
import {useNavigation, useRoute} from '@react-navigation/native';
import {CustomStatusBar} from './customStatusBar';
import {selectScreenOrientation} from '../redux/slices/ScreenOrientationSlice';
import {useSelector} from 'react-redux';
import logger from './logger';
import {Permission} from 'react-native-permissions';
//import RNFS from 'react-native-fs';
import {PermissionsAndroid} from 'react-native';
import PDFViewerMacos from './pdfViewerMacos';

export const WebViewContainerMacos = props => {
   const navigation = useNavigation();
   const params = useRoute().params;
   const isLandscapemode = useSelector(selectScreenOrientation);
   const isMacos = Platform.OS === 'macos';

   const requestStoragePermission = async () => {
      try {
         const granted = await PermissionsAndroid.request(
            PermissionsAndroid.PERMISSIONS.WRITE_EXTERNAL_STORAGE,
            {
               title: 'Storage Permission',
               message:
                  'App needs access to your storage to download the file.',
               buttonPositive: 'OK',
               buttonNegative: 'Cancel',
            },
         );
         return granted === PermissionsAndroid.RESULTS.GRANTED;
      } catch (error) {
         console.error('Error requesting storage permission:', error);
         return false;
      }
   };

   const downloadAndSavePDF = async (base64Data, fileName) => {
      /* const d = new Date();
      let ms = d.getMilliseconds();
      const name = fileName.replace('Print', '') + ms + '.pdf';
      if (Platform.OS === 'android') {
         const granted = await requestStoragePermission();
         if (!granted) {
            console.warn('Storage permission denied.');
            return;
         }
      }
      var path;
      if (Platform.OS === 'ios') {
         path = `${RNFS.DocumentDirectoryPath}/${name}`;
      } else if (Platform.OS === 'android') {
         path = `${RNFS.DownloadDirectoryPath}/${name}`;
      } else {
         // Unsupported platform
         return;
      }

      try {
         await RNFS.writeFile(
            path,
            base64Data.replace('application/pdf;base64,', ''),
            'base64',
         );

         logger('File saved:', path);
         // Share the PDF file using react-native-share
         Share.open({
            url: `file://${path}`,
            type: 'application/pdf',
         })
            .then(() => {
               logger('PDF shared successfully');
            })
            .catch(error => {
               logger('Error sharing PDF:', error);
            });
      } catch (error) {
         console.error('Error saving file:', error);
      } */
   };

   return (
      <SafeAreaView style={styles.container}>
         <CustomStatusBar
            backgroundColor={drawerListBackgroundColor}
            barStyle="light-content"
         />
         <View
            style={{
               flexDirection: 'row',
               alignItems: 'center',
               height: !isLandscapemode ? getNavBarHeight() : 88,
               backgroundColor: drawerListBackgroundColor,
               justifyContent: 'space-between',
            }}>
            <View style={{flexDirection: 'row', alignItems: 'center'}}>
               <TouchableOpacity
                  style={{padding: 10, marginTop: 0}}
                  onPress={() => {
                     props.navigation.goBack();
                  }}>
                  <Image
                     source={require('../assets/back_arrow.png')}
                     style={{
                        width: !isLandscapemode ? 16 : 24,
                        height: !isLandscapemode ? 16 : 24,
                        marginLeft: !isLandscapemode ? 7 : 10,
                     }}
                  />
               </TouchableOpacity>
            </View>

            {params.apiAction && (
               <View
                  style={{flexDirection: 'row-reverse', alignItems: 'center'}}>
                  <TouchableOpacity
                     style={{padding: 10, marginTop: 0}}
                     onPress={() => {
                        downloadAndSavePDF(params.urlPath, params.apiAction);
                     }}>
                     <Image
                        source={require('../assets/share.png')}
                        style={{
                           width: 24,
                           height: 24,
                           marginLeft: 10,
                        }}
                     />
                  </TouchableOpacity>
               </View>
            )}
         </View>
         <PDFViewerMacos urlPath={params.urlPath} />
      </SafeAreaView>
   );
};

const styles = StyleSheet.create({
   container: {
      flex: 1,
      backgroundColor: drawerListBackgroundColor,
   },
});
